import { render, staticRenderFns } from "./GameIsIterating.vue?vue&type=template&id=64a9615a"
import script from "./GameIsIterating.vue?vue&type=script&lang=js"
export * from "./GameIsIterating.vue?vue&type=script&lang=js"
import style0 from "./GameIsIterating.vue?vue&type=style&index=0&id=64a9615a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports